export default __webpack_public_path__ + "static/media/Elder Wand - Img - Final (2)_03.aa11730c.jpg";